export default "__VITE_ASSET__CKdV0UO0__"